import React from "react";
import { Paper } from "@mui/material";
import SFTypography from "../../areas/core/components/typography";
import SFuseStyled from "../../areas/core/hooks/useStyled";
import { SFStack, SFGridContainer, SFGridItem, SFButton } from "@sf-core";
import { useTranslation, Trans } from "react-i18next";

const { styled } = SFuseStyled();

const StyledPaper = styled(Paper)(({ theme }) => ({
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  padding: theme.spacing(3),
  color: theme.palette.grey50.main,
  backgroundColor: theme.palette.grey600.main,
  boxShadow: "0px -15px 20px 0px rgba(0, 0, 0, 0.20)",
}));

const StyledSpan = styled("span")(({ theme }) => ({
  cursor: "pointer",
  color: theme.palette.blue200.main,
}));

const StyledTextStack = styled(SFStack)(({ theme }) => ({
  height: "150px",
  paddingLeft: theme.spacing(4),
}));

const StyledActionStack = styled(SFStack)(({ theme }) => ({
  height: "150px",
  paddingLeft: theme.spacing(6),
}));

const StyledButton = styled(SFButton)(({ theme }) => ({
  height: "55px",
}));

const LinkText = (props) => (
  <StyledSpan onClick={props.openPopup}>{props.text}</StyledSpan>
);

const CookiesBanner = (props) => {
  const { t } = useTranslation();

  return (
    <StyledPaper elevation={1}>
      <SFGridContainer>
        <SFGridItem xs={10}>
          <StyledTextStack
            direction="column"
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <SFTypography variant="academyCardTitle">
              {t("policies.cookies.header")}
            </SFTypography>
            <SFTypography variant="body2">
              <Trans
                i18nKey="policies.cookies.caption"
                t={t}
                components={{ link: <LinkText openPopup={props.openPopup}></LinkText> }}
              />
            </SFTypography>
            <SFTypography variant="body2">
              <Trans
                i18nKey="policies.cookies.body"
                t={t}
                components={{ link: <LinkText openPopup={props.openPopup}></LinkText>  }}
              />
            </SFTypography>
            <SFTypography variant="body2">
              {t("policies.cookies.message")}
            </SFTypography>

          </StyledTextStack>
        </SFGridItem>
        <SFGridItem xs={2}>
          <StyledActionStack
            alignItems="center"
            justifyContent="center"
          >
            <StyledButton variant="transparent" onClick={props.acceptCookies}>
              {t("policies.cookies.aggreeAndDismissBtn")}
            </StyledButton>
          </StyledActionStack>
        </SFGridItem>
      </SFGridContainer>
    </StyledPaper>
  );
};

export default CookiesBanner;
